import { max, min, subtract } from "@pentacode/openapi";
import { BreakMode } from "./model";
/**
 * Calculates the break time for a given work duration required by law.
 *
 * @param shiftDuration - The duration of the shift.
 * @param iterativeBreaks - If true, the break is subtracted from the given duration before calculating the break.
 */
export function getStatutoryBreak(shiftDuration, { iterativeBreaks = false } = { iterativeBreaks: false }) {
    if (shiftDuration <= 6) {
        return 0;
    }
    else if (shiftDuration <= (iterativeBreaks ? 9.5 : 9)) {
        return 0.5;
    }
    else {
        return 0.75;
    }
}
/**
 * Get the automatic break for a given duration. The thresholds can be defined individually using {@link TimeSettings.autoBreaks} but default to the
 * statuatory breaks in standardMode.
 *
 * @returns
 */
export function getAutomaticBreak(shiftDuration, { breakMode, autoBreaks = [] }) {
    if (breakMode === BreakMode.Manual) {
        return 0;
    }
    return max(0, ...autoBreaks.filter((b) => b.duration < shiftDuration).map((b) => b.amount));
}
function calculateBreakDurationsPlanned(entry, timeSettings, duration, iterativeBreaks) {
    let auto;
    if (entry.breakAuto != null) {
        auto = entry.breakAuto;
    }
    else if (timeSettings.breakMode === BreakMode.Manual) {
        auto = getStatutoryBreak(duration, { iterativeBreaks });
    }
    else if ([BreakMode.Planned, BreakMode.PlannedPlusManual].includes(timeSettings.breakMode)) {
        auto = entry.breakPlanned || 0;
    }
    else {
        auto = getAutomaticBreak(duration, timeSettings);
    }
    return { manual: 0, auto };
}
export function calculateBreakDurationsFinalized(entry, timeSettings, duration) {
    const breakFinal = entry.break || 0;
    let auto;
    if (entry.breakAuto != null) {
        auto = entry.breakAuto;
    }
    else if ([BreakMode.Planned, BreakMode.PlannedPlusManual].includes(timeSettings.breakMode)) {
        auto = entry.breakPlanned || 0;
    }
    else {
        auto = min(breakFinal, getAutomaticBreak(duration, timeSettings));
    }
    const manual = subtract(breakFinal, auto);
    return { manual, auto };
}
export function calculateBreakDurations(entry, timeSettings, timeResultMode, duration, iterativeBreaks) {
    if (timeResultMode === "planned" || (timeResultMode === "mixed" && !entry.isPast && !entry.final)) {
        return calculateBreakDurationsPlanned(entry, timeSettings, duration, iterativeBreaks);
    }
    return calculateBreakDurationsFinalized(entry, timeSettings, duration);
}
//# sourceMappingURL=breaks.js.map